export default __webpack_public_path__ + "static/media/under_const.ea09f0fc.png";